import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Images } from "../../../../assets/assets";
import './ProjectStats.css';
import { useOnScreenFetch } from '../../../lib/useOnScreenFetch';
import { useProjectStore } from '../../../../store/useProjectStore';
import { useHomeStore } from '../../../../store/useHomeStore';
import { useState } from 'react';
import Loader from '../../../Loader';

const stats = [
  {
    icon: Images.EarthIcon,
    value: '1M+',
    label: 'CY of Earth Moved',
    fieldName: 'earthMoved',
  },
  {
    icon: Images.ConcreteIcon,
    value: '50K+',
    label: 'CY of Concrete Poured',
    fieldName: 'concretePoured',
  },
  {
    icon: Images.HandshakeIcon,
    value: '1K+',
    label: 'Completed Projects',
    fieldName: 'completedProject',
  },
  {
    icon: Images.BuildingIcon,
    value: '2009',
    label: 'Year Established',
    fieldName: 'yearOfEstablishment',
  },
];

export default function ProjectStats() {
  let { getHome, analytics } = useHomeStore()
  const [loading, setLoading] = useState(false)

  const getAnalysticsFunction = async () => {
    if (analytics) return
    setLoading(true)
    await getHome()
    setLoading(false)
  }

  useEffect(() => {
    getAnalysticsFunction()
  }, [])
  return (
    <Loader loading={loading}>
      <div className="stats-section">
        <Container>
          <Row className="text-center">
            {stats.map((item, idx) => (
              <Col md={3} sm={6} xs={12} key={idx} className="stat-item">
                <img src={item.icon} alt="icon" className="stat-icon" />
                <h2 className="stat-value mb-2">
                  {analytics?.[item?.fieldName]}</h2>
                <h6 className="stat-label">{item.label}</h6>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </Loader>
  );
}
